import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Fix: Prevent crash when browser extensions (Google Translate, Grammarly, etc.)
// or injected scripts (Cloudflare Rocket Loader) modify DOM nodes that React manages.
// React calls removeChild/insertBefore expecting nodes to be direct children,
// but extensions can wrap/move text nodes, breaking that assumption.
if (typeof Node !== 'undefined') {
  const origRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (child.parentNode) {
        return child.parentNode.removeChild(child);
      }
      return child;
    }
    return origRemoveChild.apply(this, arguments);
  };

  const origInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, refNode) {
    if (refNode && refNode.parentNode !== this) {
      return origInsertBefore.call(this, newNode, null);
    }
    return origInsertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
